/* src/app/modules/search/components/search-chat/components/search-chat-history/search-chat-history.component.scss */
.search-chat-history {
  overflow-x: hidden;
  overflow-y: auto;
}
.search-chat-history ::ng-deep .text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  font-weight: 400;
}
:host ::ng-deep .p-scroller-viewport {
  flex: none;
}
:host ::ng-deep p-skeleton {
  width: 100%;
}
/*# sourceMappingURL=search-chat-history.component.css.map */
